import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';
import Activities from './Activities'
import History from './History'
import Schedule from './Schedule'
import ScheduleDataMarking from './ScheduleDataMarking';
// Component styles
import styles from './styles';

class Maintenance extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.state = {
            online:null,
            value: this.props?.location?.query?.tab ?? 0,
            dataMaintenance: this.props?.location?.query?.dataMaintenance ?? {},
        }
    }

    myCallback = (dataFromChild) => {
        this.setState({
            objectivesList: dataFromChild
        })
    }
    handleInfo(value) {
        this.setState({
            value: value,
            dataMaintenance: {}
            //updateDisabled: true,
            //alertobjectives: null
        });
    }

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
            dataMaintenance: {}
            //updateDisabled: true,
            //alertobjectives: null
        });
    };
    render() {
        const {value, dataMaintenance}=this.state
        const { t } = this.props;
        let admin = sessionStorage.getItem('admin')
        return (
            <DashboardLayout  title={t ? t('maintenance.title') : 'Mantenimientos'}  callbackFromParent={this.myCallback} isFirstTime={false}>
                <AppBar position="static" style={{ backgroundColor: '#333333' }}>
                        <Tabs value={value} onChange={this.handleChange} aria-label="simple tabs example">
                            <Tab label={t ? t('maintenance.tabs.activities') : 'Actividades Programadas'} style={{paddingTop:"15px"}} />
                            <Tab label={t ? t('maintenance.tabs.history') : 'Historial'} style={{paddingTop:"15px"}}/>
                            <Tab label={t ? t('maintenance.tabs.schedule') : 'Agendar'} style={{paddingTop:"15px"}}/>
                            <Tab label={t ? t('maintenance.tabs.scheduleAtentus') : 'Agendar Atentus'} style={{paddingTop:"15px", display: admin? {} : 'none'}}/>
                        </Tabs>
                </AppBar>
                    { value == 0 ? 
                        <Activities/>   
                    : value == 1 ?
                        <History/> 
                    : value == 2?
                        <Schedule onInfo={this.handleInfo} dataMaintenance={dataMaintenance}/>
                    : value == 3?
                        <ScheduleDataMarking onInfo={this.handleInfo} dataMaintenance={dataMaintenance}/>
                    :null }
            </DashboardLayout>
            
        );
    }
}


export default compose(withWidth(), withStyles(styles), withTranslation())(Maintenance);
